<!-- =========================================================================================
    File Name: ProductGeneralEditorCard.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card title="General">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

    <!--  COMPANY + CODE ROW    -->
    <div class="vx-row mb-2 pt-2">
    <!--   COMPANY   -->
      <div class="vx-col md:w-1/2 w-full">
        <vs-select
          label="Company"
          v-model="workingProduct.company_id"
          class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
          <vs-select-item
            v-for="item in companies"
            :key="item.company_id"
            :value="item.company_id"
            :text="item.name"/>
        </vs-select>
      </div>
      <!--   CODE   -->
      <div class="vx-col md:w-1/2  w-full">
        <vs-input
          label-placeholder="Code"
          v-model="workingProduct.code"
          class="w-full"
        />
      </div>
    </div>

    <!--  OPTIONS + IMAGES ROW    -->
    <div class="vx-row mb-2 pt-2">
      <!--  TOGGLES AND DROP DOWNS    -->
      <div :class="`vx-col ${isNewProduct ? 'md:w-full' : 'md:w-1/3'}`">

        <!--   TYPE   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <vs-select
              label="Type"
              v-model="workingProduct.product_type_id"
              class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
              <vs-select-item
                v-for="item in allProductTypes"
                :key="item.product_type_id"
                :value="item.product_type_id"
                :text="item.name"/>
            </vs-select>
          </div>
        </div>
        <!--   GENDER   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <vs-select
              label="Gender"
              v-model="workingProduct.gender"
              class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
              <vs-select-item
                v-for="item in genderOptions"
                :key="item.value"
                :value="item.value"
                :text="item.name"/>
            </vs-select>
          </div>
        </div>

        <!--   ACTIVE   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="active-switch">Active</label>
            <vs-switch
              id="active-switch"
              color="success"
              v-bind:checked="activeBool"
              v-on:input="toggleActive"/>
          </div>
        </div>

        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="active-switch">Enrollment Kit</label>
            <vs-switch
              id="enrollment_kit_switch"
              color="success"
              v-bind:checked="enrollmentKitBool"
              v-on:input="toggleEnrollmentKit" />
          </div>
        </div>

        <!--   Not Sold Individually   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="nsi-switch">Not Sold Individually</label>
            <vs-switch
              id="nsi-switch"
              color="success"
              v-bind:checked="notSoldIndivBool"
              v-on:input="toggleSoldIndividually"/>
          </div>
        </div>

        <!--   PREGNANT   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="preg-switch">Unsafe for pregnancy</label>
            <vs-switch
              id="preg-switch"
              color="warning"
              v-bind:checked="pregBool"
              v-on:input="togglePregnant"/>
          </div>
        </div>

        <!--   SENIORS (50+) ONLY   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="a-only-switch">Seniors (50+) Only</label>
            <vs-switch
              id="a-only-switch"
              color="warning"
              v-bind:checked="seniorsOnlyBool"
              v-on:input="toggleSeniorsOnly"/>
          </div>
        </div>

        <!--   ADULTS ONLY   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="a-only-switch">Adults Only</label>
            <vs-switch
              id="a-only-switch"
              color="warning"
              v-bind:checked="adultsOnlyBool"
              v-on:input="toggleAdultsOnly"/>
          </div>
        </div>

        <!--   CHILDREN ONLY   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="c-only-switch">Children Only</label>
            <vs-switch
              id="c-only-switch"
              color="warning"
              v-bind:checked="childrenOnlyBool"
              v-on:input="toggleChildrenOnly"/>
          </div>
        </div>


        <!--   Animal Safe   -->
        <div class="vx-row mb-2 pt-2">
          <div class="vx-col w-full">
            <label class="label" for="nsi-switch">Animal Safe</label>
            <vs-switch
              id="animal-safe-switch"
              color="success"
              v-bind:checked="animalSafeBool"
              v-on:input="toggleAnimalSafe"/>
          </div>
        </div>

      </div>

      <!--   IMAGES   -->
      <div v-if="!isNewProduct" class="vx-col md:w-2/3 sm:w-full">
        <div class="vx-row mt-1">
          <div class="vx-col w-full">
            <ItoviImageUpload
              :initial-image-url="helpers.getImage(workingProduct)"
              :identifier="'primary'"
              :required-aspect-ratio="1"
              label-top="PNG with transparent background. 1:1 aspect ratio required (i.e. 500x500)"
              button-text="Primary"
              @imageSelected="uploadPrimaryImage"
            ></ItoviImageUpload>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <ItoviImageUpload
              :initial-image-url="helpers.getImage(workingProduct, 'secondary')"
              :identifier="'secondary'"
              :required-aspect-ratio="1.2"
              label-top="6:5 aspect ratio required (i.e. 540x450)"
              button-text="Background"
              @imageSelected="uploadSecondaryImage"
            ></ItoviImageUpload>
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-5">
        <vs-textarea
          width="100%"
          label="Internal Notes"
          v-model="workingProduct.internal_notes"
        />
      </div>
      <div v-if="!isNewProduct" class="vx-col w-full mt-3">
        <label class="vs-input--label">{{ selectedUsageTypeIds.length }} Protocol Uses</label>
        <v-select
          multiple
          label="name_internal"
          :value="selectedUsageTypes"
          :reduce="ut => ut.id"
          :options="unSelectedUsageTypes"
          @input="usageTypeSelectionChanged"
        />
      </div>
    </div>

    <div class="vx-row">
      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2">
        <vs-button class="mx-1 w-full" @click="saveChanges">{{ isNewProduct ? 'Create' : 'Save Changes' }}</vs-button>
      </div>
      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2">
        <vs-button class="mx-1 w-full" color="warning" type="border" @click="revert">
          Cancel
        </vs-button>
      </div>
    </div>

  </vx-card>
</template>

<script>
  import types from '@/models';
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';
  import ItoviImageUpload from '../../../../layouts/components/ItoviImageUpload';

  export default {
    components: {
      ItoviImageUpload,
    },
    data() {
      return {
        loading: false,
        helpers: productHelpers,
        originalProduct: new types.Product(),
        workingProduct: new types.Product(),
        genderOptions: [
          {name: 'Any', value: null},
          {name: 'Male Only', value: 1},
          {name: 'Female Only', value: 0},
        ],
        allUsageTypes: [],
        selectedUsageTypeIds: [],
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
        default: () => {
          return [new types.Company()]
        }
      },
      allProductTypes: {
        type: Array,
        required: true,
        default: () => {
          return [new types.ProductType()]
        }
      },
    },
    mounted() {
      if (this.product.product_id) {
        this.fetchUsageTypes();
      }
    },
    watch: {
      product: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.originalProduct = JSON.parse(JSON.stringify(newVal));
        this.workingProduct = JSON.parse(JSON.stringify(newVal));
        if (newVal.product_id) this.fetchUsageTypes();
      },
      isModified: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        this.$emit('unsavedChangesUpdate', newVal);
      }
    },
    computed: {
      isModified() {
        return JSON.stringify(this.originalProduct) !== JSON.stringify(this.workingProduct);
      },
      activeBool() {
        return this.workingProduct.active === 1;
      },
      enrollmentKitBool() {
        return this.workingProduct.enrollment_kit;
      },
      notSoldIndivBool() {
        return this.workingProduct.group_only_sale;
      },
      animalSafeBool() {
        return this.workingProduct.animal_safe;
      },
      pregBool() {
        return this.workingProduct.preg_or_nurse === 1;
      },
      seniorsOnlyBool() {
        return this.workingProduct.min_age !== null && this.workingProduct.min_age >= 50;
      },
      adultsOnlyBool() {
        return this.workingProduct.min_age !== null && this.workingProduct.min_age >= 12 && this.workingProduct.min_age < 50;
      },
      childrenOnlyBool() {
        return this.workingProduct.max_age !== null && this.workingProduct.max_age <= 12 && this.workingProduct.min_age == null;
      },
      isNewProduct() {
        return this.product.product_id === 0;
      },
      selectedUsageTypes() {
        return this.allUsageTypes.filter(ut => this.selectedUsageTypeIds.includes(ut.id));
      },
      unSelectedUsageTypes() {
        return this.allUsageTypes.filter(ut => !this.selectedUsageTypeIds.includes(ut.id));
      }
    },
    methods: {
      async fetchUsageTypes() {
        const [allTypes, productTypes] = await Promise.all([
          api.getProtocolUsageTypes(),
          api.getProductProtocolUsageTypes(this.product.product_id)
        ]);
        this.allUsageTypes = allTypes;
        this.selectedUsageTypeIds = productTypes.map(pt => pt.usage_type_id);
      },
      async usageTypeSelectionChanged(newSelectedIds) {
        if (newSelectedIds.length === this.selectedUsageTypeIds.length) return;
        const added = newSelectedIds.length > this.selectedUsageTypeIds.length;

        let success = false;
        if (added) {
          const addedId = newSelectedIds.find(id => !this.selectedUsageTypeIds.includes(id));
          success = await api.addProductProtocolUsageType(this.product.product_id, addedId);
        } else {
          const removedId = this.selectedUsageTypeIds.find(id => !newSelectedIds.includes(id));
          success = await api.removeProductProtocolUsageType(this.product.product_id, removedId);
        }

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: added ? `Protocol use${success ? '' : ' NOT'} added.` : `Protocol use${success ? '' : ' NOT'} removed.`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error_outline'
        });

        this.selectedUsageTypeIds = newSelectedIds;
      },
      revert() {
        this.workingProduct = JSON.parse(JSON.stringify(this.originalProduct));
      },
      toggleActive() {
        if (this.activeBool) {
          this.workingProduct.active = 0;
        } else {
          this.workingProduct.active = 1;
        }
      },
      toggleEnrollmentKit() {
        if (this.enrollmentKitBool) {
          this.workingProduct.enrollment_kit = 0;
        } else {
          this.workingProduct.enrollment_kit = 1;
        }
      },
      toggleSoldIndividually() {
        if (this.notSoldIndivBool) {
          this.workingProduct.group_only_sale = 0;
        } else {
          this.workingProduct.group_only_sale = 1;
        }
      },
      toggleAnimalSafe() {
        this.workingProduct.animal_safe = !this.animalSafeBool;
      },
      togglePregnant() {
        if (this.pregBool) {
          this.workingProduct.preg_or_nurse = 0;
        } else {
          this.workingProduct.preg_or_nurse = 1;
        }
      },
      toggleSeniorsOnly() {
        if (this.seniorsOnlyBool) {
          this.workingProduct.min_age = null;
        } else {
          this.workingProduct.max_age = null;
          this.workingProduct.min_age = 50;
        }
      },
      toggleAdultsOnly() {
        if (this.adultsOnlyBool) {
          this.workingProduct.min_age = null;
        } else {
          this.workingProduct.max_age = null;
          this.workingProduct.min_age = 12;
        }
      },
      toggleChildrenOnly() {
        if (this.childrenOnlyBool) {
          this.workingProduct.max_age = null;
        } else {
          this.workingProduct.min_age = null;
          this.workingProduct.max_age = 12;
        }
      },
      async createProduct(){
        this.loading = true;
        const newProduct = await api.createNewProduct(this.workingProduct);
        const success = newProduct !== null && newProduct.product_id !== 0;

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `Product created successfully` : `Error creating product`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});

        this.originalProduct = JSON.parse(JSON.stringify(this.workingProduct));

        this.revert();

        this.$emit('productChanged', newProduct);

        this.loading = false;
      },
      async saveChanges() {
        if (!this.isModified) return;
        // handle if this is a NEW product
        if (this.workingProduct.product_id === 0) {
          this.createProduct();
          return;
        }
        this.loading = true;

        let success = await api.saveProductBaseProperties(this.workingProduct);

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `Changes successfully saved` : `Error saving changes`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});

        this.originalProduct = JSON.parse(JSON.stringify(this.workingProduct));

        this.revert();

        this.$emit('productChanged');

        this.loading = false;
      },
      async uploadPrimaryImage(image) {
        console.log('uploadPrimaryImage()...');
        let images = await api.postProductPrimaryImage(this.product, image);
        if (images === null) {
          this.showNotification(false, 'Error uploading image');
        } else {
          this.product.images = images;
          this.showNotification(true, 'Image uploaded');
        }
      },
      async uploadSecondaryImage(image) {
        let images = await api.postProductSecondaryImage(this.product, image);
        if (images === null) {
          this.showNotification(false, 'Error uploading image');
        } else {
          this.product.images = images;
          this.showNotification(true, 'Image uploaded');
        }
      },
      showNotification(title = 'Alert', message = '', color = 'success', icon = 'error_outline') {
        this.$vs.notify({
          title: title,
          text: message,
          color: color,
          icon: icon
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .center-container {
    position: relative;
  }
  .upload-button-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .product-image {
    object-fit: scale-down;
    object-position: 50% 50%;
    width: 100%;
    max-height: 150px;
  }
</style>
